
import { Options, Vue, mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';

@Options({
    components: {
    }
})
export default class editLayersComponent extends Vue {

    @Prop() item: OM.LayerComposition = new OM.LayerComposition();

    created() {
    }
}
